<template>
	<div class="p-switch" :class="classes">
		<p v-if="firstLabel" class="p-switch__label" @click="emit('update:modelValue', false)">{{ firstLabel }}</p>
		<div class="p-switch__container p-switch_default">
			<button class="p-switch__button" :disabled="disabled" @click="emit('update:modelValue', !modelValue)">
				<span />
			</button>
			<slot />
		</div>
		<p v-if="secondLabel" class="p-switch__label" @click="emit('update:modelValue', true)">{{ secondLabel }}</p>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
interface Props {
	modelValue?: boolean;
	disabled?: boolean;
	firstLabel?: string;
	secondLabel?: string;
}

const props = defineProps<Props>();

const classes = computed(() => ({
	'p-switch_disabled': props.disabled,
	'p-switch_active': props.modelValue,
}));

const emit = defineEmits(['update:modelValue']);
</script>

<style>
@import "styles/pSwitch.scss";
</style>